// reduxjs toolkit
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import BaseUrl from "../../service/API/base_url";
import { handleSuccess, handleError } from "../../utils/toast";

const handleApiResponse = (response, thunkAPI, successMessage) => {
  if (response.status === 200 || response.status === 201) {
    if (successMessage) handleSuccess(successMessage);
    return response.data;
  } else {
    handleError(response.message);
    return thunkAPI.rejectWithValue(response.data);
  }
};

const handleApiError = (error, thunkAPI, errorMessage) => {
  handleError(error.response?.data?.message || errorMessage);
  return thunkAPI.rejectWithValue(error.response?.data);
};

// List all Teams
export const viewTeams = createAsyncThunk("teams", async (_, thunkAPI) => {
  try {
    const response = await axios.get(`${BaseUrl}backend-api/teams/data`);
    return handleApiResponse(response, thunkAPI);
  } catch (e) {
    return handleApiError(e, thunkAPI, "loading...");
  }
});

// Add new teams
export const registerTeams = createAsyncThunk(
  "teams",
  async (teamsData, thunkAPI) => {
    try {
      const response = await axios.post(
        `${BaseUrl}backend-api/teams`,
        teamsData,
      );

      return handleApiResponse(response, thunkAPI, "Register successful!");
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  },
);

// Search Teams by ID
export const singleTeams = createAsyncThunk("teams", async (id, thunkAPI) => {
  try {
    const response = await axios.get(`${BaseUrl}backend-api/teams/${id}`);
    return handleApiResponse(response, thunkAPI);
  } catch (e) {
    return handleApiError(e, thunkAPI, "search maintenance history...");
  }
});

// Update Teams
export const updateTeams = createAsyncThunk(
  "teams",
  async ({ id, formData }, thunkAPI) => {
    try {
      const response = await axios.put(
        `${BaseUrl}backend-api/teams/${id}`,
        formData,
      );
      return handleApiResponse(response, thunkAPI, "Change saved successfully");
    } catch (e) {
      return handleApiError(e, thunkAPI);
    }
  },
);

// Delete Teams
export const deleteTeams = createAsyncThunk("teams", async (id, thunkAPI) => {
  const token = JSON.parse(localStorage.getItem("userInfo")) || null;
  try {
    const response = await axios.delete(`${BaseUrl}backend-api/teams/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return handleApiResponse(response, thunkAPI, "Delete successful!");
  } catch (e) {
    return handleApiError(e, thunkAPI);
  }
});
